import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainLayout from "@/components/layout/MainLayout";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

const RegistrationConfirmation = () => {
  const { t } = useTranslation();
  // Получаем email из URL параметров
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email') || '';

  return (
    <MainLayout>
      <div className="container-page flex items-center justify-center py-8 md:py-16">
        <div className="w-full max-w-md bg-card p-6 md:p-8 rounded-lg border shadow-sm">
          <div className="text-center mb-6">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-brand-50 rounded-full flex items-center justify-center">
                <Mail className="h-8 w-8 text-brand-600" />
              </div>
            </div>
            <h1 className="text-2xl font-bold">{t('registration_confirm.title')}</h1>
            <p className="text-muted-foreground mt-2">
              {t('registration_confirm.sent_message')}
            </p>
            <p className="font-medium mt-1">{email}</p>
          </div>

          <div className="space-y-4">
            <div className="bg-amber-50 border border-amber-200 rounded-md p-4 text-sm text-amber-800">
              <p>{t('registration_confirm.check_email')}</p>
            </div>

            <div className="text-center text-sm text-muted-foreground">
              <p>{t('registration_confirm.not_received')}</p>
              <p className="mt-1">
                {t('registration_confirm.spam_check')}{" "}
                <Link to="/login" className="text-brand-600 font-medium hover:underline">
                  {t('registration_confirm.try_login')}
                </Link>
              </p>
            </div>

            <div className="pt-4">
              <Link to="/login">
                <Button variant="outline" className="w-full">
                  {t('registration_confirm.back_to_login')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RegistrationConfirmation;